import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import WireFrameCell from '../../../../elements/wireframe-cell';
import { CellContext } from '../generics';
import ProductTable from '../index';
import { ROWS } from './cell-split';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var WireFrame = function WireFrame(_ref) {
  var type = _ref.type;
  var containerStyles = {
    header: {
      width: '100%'
    },
    info: {
      margin: '18px 0'
    }
  };
  var defaultStyles = {
    header: {
      width: ['93%', '35%'],
      height: '14px'
    },
    info: {
      height: '10px',
      width: ['90%', '70%'],
      marginLeft: '0',
      marginTop: '10px'
    },
    example: {
      height: '11px',
      width: ['90%', '70%'],
      marginLeft: '0',
      marginTop: '8px'
    }
  };
  var rowStyles = {
    header: [_objectSpread({}, defaultStyles.header), _objectSpread(_objectSpread({}, defaultStyles.header), {}, {
      width: '45%',
      display: ['block', 'none'],
      marginTop: '11px',
      marginBottom: '20px'
    })],
    info: [_objectSpread(_objectSpread({}, defaultStyles.info), {}, {
      marginTop: '14px'
    }), _objectSpread({}, defaultStyles.info), _objectSpread(_objectSpread({}, defaultStyles.info), {}, {
      width: '45%',
      display: ['block', 'none']
    })],
    example: [_objectSpread({}, defaultStyles.example), _objectSpread({}, defaultStyles.example), _objectSpread(_objectSpread({}, defaultStyles.example), {}, {
      width: '86%',
      display: ['block', 'none']
    }), _objectSpread(_objectSpread({}, defaultStyles.example), {}, {
      width: '86%',
      display: ['block', 'none']
    }), _objectSpread(_objectSpread({}, defaultStyles.example), {}, {
      width: '25%',
      display: ['block', 'none']
    })]
  };

  var contextProviderWrapper = function contextProviderWrapper(children, type) {
    if (type === 'header') {
      return children;
    }

    return _jsx(CellContext.Provider, {
      value: {
        gridRowStart: ROWS + (type === 'info' ? 5 : 6),
        gridRowSpan: 1,
        gridColumnStart: 1,
        gridColumnSpan: 6
      },
      children: _jsx(ProductTable.cells.Base, {
        children: children
      })
    });
  };

  return contextProviderWrapper(_jsx("div", {
    sx: type !== 'example' && _objectSpread({}, containerStyles[type]) || undefined,
    children: rowStyles[type].map(function (item, key) {
      return _jsx(WireFrameCell, {
        styles: item
      }, key);
    })
  }), type);
};
//# sourceMappingURL=wireframe-cell.js.map